/**
 * Site name appended to every page title by `SeoService.setTitle`.
 * Kept here so the duplicate check cannot drift from the value being appended.
 */
const SITE_NAME = 'Handyhand';

/**
 * Remove a trailing site-name suffix from a CMS-authored title.
 *
 * `SeoService.setTitle` always appends ` - Handyhand`. Many mini-vertical titles
 * already end in `| Handyhand` because the brand was baked into the copy, which
 * renders as `... | Handyhand - Handyhand`. Stripping the authored suffix leaves
 * exactly one brand mention and reclaims ~12 characters of the ~60 Google
 * displays.
 *
 * Handles the separators found in the data (`|`, en dash, em dash, hyphen) and
 * is case-insensitive on the brand. Titles without the suffix are returned
 * unchanged, so this is safe to apply unconditionally.
 */
export function stripTrailingSiteName(title: string): string {
  if (!title) return title;

  const pattern = new RegExp(`\\s*[|\\-–—]\\s*${SITE_NAME}\\s*$`, 'iu');
  const stripped = title.replace(pattern, '').trim();

  // Never return an empty title just because the copy was only the brand name.
  return stripped.length > 0 ? stripped : title.trim();
}
